import frame_10 from './assets/frames/candy.png';
import frame_1 from './assets/frames/emerald.png';
import frame_2 from './assets/frames/winter.png';
import frame_3 from './assets/frames/pumpkin.png';
import frame_4 from './assets/frames/pastel-stars.png';
import frame_5 from './assets/frames/autumn.png';
import frame_6 from './assets/frames/blossom.png';
import frame_7 from './assets/frames/hearts.png';
import frame_8 from './assets/frames/woodland.png';
import frame_9 from './assets/frames/moon.png';
import selected_E01 from './assets/frames/selected-e01.png';
import selected_E02 from './assets/frames/selected-e02.png';
import selected_E03 from './assets/frames/selected-e03.png';
import selected_E05 from './assets/frames/selected-e05.png';
import type { FrameEffects } from './AvatarFrameDecoration';
export interface AvatarFrame {
  name: string;
  galleryId?: string;
  size: number;
  centerX: number;
  centerY: number;
  src: string;
  backdrop: string;
  avatarScale?: number;
  /** Normalize visible artwork bounds, rather than transparent PNG canvas size. */
  displayScale?: number;
  effects?: FrameEffects;
}
const legacyFrames: AvatarFrame[] = [
  { name: 'frame_1', size: 162, centerX: 50.81, centerY: 52.3, src: frame_1, backdrop: '#103B32' },
  { name: 'frame_2', size: 151, centerX: 50.68, centerY: 46.43, src: frame_2, backdrop: '#173D58' },
  { name: 'frame_3', size: 156, centerX: 48.5, centerY: 53.34, src: frame_3, backdrop: '#38213F' },
  { name: 'frame_4', size: 156, centerX: 51.49, centerY: 51.72, src: frame_4, backdrop: '#40305F' },
  { name: 'frame_5', size: 161, centerX: 52.76, centerY: 51.61, src: frame_5, backdrop: '#45291F' },
  { name: 'frame_6', size: 156, centerX: 48.5, centerY: 47.58, src: frame_6, backdrop: '#344338' },
  { name: 'frame_7', size: 156, centerX: 48.62, centerY: 48.96, src: frame_7, backdrop: '#592C43' },
  { name: 'frame_8', size: 156, centerX: 50.92, centerY: 48.74, src: frame_8, backdrop: '#30432B' },
  { name: 'frame_9', size: 158, centerX: 54.03, centerY: 48.85, src: frame_9, backdrop: '#1D204B' },
  {
    name: 'frame_10',
    src: frame_10,
    backdrop: '#573B50',
    size: 145,
    centerX: 50.68,
    centerY: 52.11,
  },
];

/** Approved collection. Existing persisted IDs keep their original artwork. */
export const avatarFrames: AvatarFrame[] = [
  {
    name: 'frame_2',
    galleryId: 'D02',
    displayScale: 0.95104,
    size: 151.0,
    centerX: 50.68,
    centerY: 46.43,
    backdrop: 'radial-gradient(circle at 40% 30%, #123368, #061536)',
    avatarScale: 0.60,
    effects: {
      starColors: ['#ffffff', '#ffffff', '#ffffff'],
      starGlow: ['#a8d6ff', '#7bbdff'],
      falling: 'snow',
    },
    src: frame_2,
  },
  {
    name: 'frame_1',
    galleryId: 'D01',
    displayScale: 1.00463,
    size: 162.0,
    centerX: 50.81,
    centerY: 52.3,
    backdrop: 'radial-gradient(circle at 35% 25%, #205347 0%, #103b32 50%, #071f1b 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#fffbe3', '#ffe58a', '#ffc444'],
      starGlow: ['#ffd365', '#e9a629'],
      falling: 'gold',
    },
    src: frame_1,
  },
  {
    name: 'frame_5',
    galleryId: 'D05',
    displayScale: 1.05482,
    size: 161.0,
    centerX: 52.76,
    centerY: 51.61,
    backdrop: 'radial-gradient(circle at 35% 25%, #c96b24 0%, #974313 50%, #56250d 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#ffe8c6', '#ffb565', '#f78b35'],
      starGlow: ['#ffae57', '#ed782b'],
      falling: 'leaves',
    },
    src: frame_5,
  },
  {
    name: 'frame_7',
    galleryId: 'D07',
    displayScale: 1.02337,
    size: 156.0,
    centerX: 48.62,
    centerY: 48.96,
    backdrop: 'radial-gradient(circle at 35% 25%, #89364b 0%, #601e30 50%, #2c0b1d 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#fff0f3', '#ffd0db', '#ee9bb0'],
      starGlow: ['#f3a5b7', '#d66c89'],
      falling: 'hearts',
    },
    src: frame_7,
  },
  {
    name: 'frame_8',
    galleryId: 'D08',
    displayScale: 0.99064,
    size: 156.0,
    centerX: 50.92,
    centerY: 48.74,
    backdrop: 'radial-gradient(circle at 35% 25%, #49633b 0%, #30432b 50%, #182419 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#f4ffe9', '#d8efbe', '#b6d994'],
      starGlow: ['#b9dc98', '#87b76c'],
      falling: 'flowers',
    },
    src: frame_8,
  },
  {
    name: 'frame_9',
    galleryId: 'D09',
    displayScale: 1.01595,
    size: 158.0,
    centerX: 54.03,
    centerY: 48.85,
    backdrop: 'radial-gradient(circle at 35% 25%, #49306b 0%, #30244f 50%, #141b3d 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#f6edff', '#d9bcfa', '#b98ae8'],
      starGlow: ['#c69afa', '#9764cf'],
      falling: 'snow',
      extraStar: true,
      fallingColor: '#dfc3ff',
    },
    src: frame_9,
  },
  {
    name: 'frame_11',
    galleryId: 'E01',
    displayScale: 0.80581,
    size: 171.75325,
    centerX: 51.98488,
    centerY: 51.32325,
    backdrop: 'radial-gradient(circle at 35% 25%, #963449 0%, #702031 50%, #360e20 100%)',
    avatarScale: 0.72,
    effects: {
      starColors: ['#ffeaf0', '#ffc1d1', '#eb8ca5'],
      starGlow: ['#ef99af', '#cf5979'],
      falling: 'snow',
      fallingColor: '#f5b1bd',
    },
    src: selected_E01,
  },
  {
    name: 'frame_12',
    galleryId: 'E02',
    displayScale: 0.87287,
    size: 159.16399,
    centerX: 49.29293,
    centerY: 52.52525,
    backdrop: 'radial-gradient(circle at 35% 25%, #38658f 0%, #29517d 50%, #162e50 100%)',
    avatarScale: 0.7,
    effects: {
      starColors: ['#ffffff', '#ffffff', '#ffffff'],
      starGlow: ['#a8d6ff', '#7bbdff'],
      falling: 'snow',
    },
    src: selected_E02,
  },
  {
    name: 'frame_13',
    galleryId: 'E03',
    displayScale: 0.85322,
    size: 162.82895,
    centerX: 49.09091,
    centerY: 53.33333,
    backdrop: 'radial-gradient(circle at 40% 30%, #173e32, #111d2c)',
    avatarScale: 0.66,
    effects: {
      starColors: ['#f6ffed', '#dfefca', '#bedb9f'],
      starGlow: ['#bedfa6', '#91bb78'],
      falling: 'snow',
    },
    src: selected_E03,
  },
  {
    name: 'frame_14',
    galleryId: 'E05',
    displayScale: 0.88977,
    size: 156.11285,
    centerX: 49.49799,
    centerY: 50.1004,
    backdrop: 'radial-gradient(circle at 35% 25%, #98465d 0%, #702e43 50%, #401923 100%)',
    avatarScale: 0.64,
    effects: {
      starColors: ['#fff1f7', '#fbd1e5', '#eaa8cb'],
      starGlow: ['#efb4d0', '#ce86ad'],
      falling: 'flowers',
    },
    src: selected_E05,
  },
];
export function avatarFrameFor(name?: string | null) {
  return (
    avatarFrames.find((frame) => frame.name === name) ??
    legacyFrames.find((frame) => frame.name === name)
  );
}
